import { createNS } from "@ontologies/core";

const dbdt = createNS("http://dbpedia.org/datatype/");

export default {
  ns: dbdt,
};
